<template>
    <el-row class="warp">
        <!--新增对话框界面 begin-->
        <el-dialog 
            title="新增用户" 
            :visible.sync="addFormVisible" 
            :close-on-click-modal="false"
        >
            <el-form :model="addForm" label-width="150px" :rules="addFormRules" ref="addForm">
                <!-- 创建form -->
                <el-form-item label="用户名：" prop="username">
                    <el-input v-model="addForm.username" placeholder="在此输入用户名"></el-input>
                </el-form-item>
                <el-form-item label="密码：" prop="password">
                    <el-input v-model="addForm.password" placeholder="在此输入8位含数字和字母密码"></el-input>
                </el-form-item>
                <el-form-item label="姓名：" prop="realname">
                    <el-input v-model="addForm.realname" placeholder="在此输入中文姓名"></el-input>
                </el-form-item>
                <el-form-item label="邮箱：" prop="mail">
                    <el-input v-model="addForm.mail" placeholder="在此输入联系邮箱"></el-input>
                </el-form-item>
                <el-form-item label="电话：" prop="phone">
                    <el-input v-model="addForm.phone" placeholder="在此输入联系电话"></el-input>
                </el-form-item>
                <el-form-item label="角色：" prop="roleValue">
                    <el-select v-model="addForm.roleValue" placeholder="请选择角色" @change="roleSelectChanged">
                        <el-option
                        v-for="item in roleOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="管理期刊：" prop="checkdedJournals">
                    <el-transfer
                        filterable
                        filter-placeholder="请输入期刊名称"
                        v-model="addForm.checkdedJournals"
                        :data="addForm.journalList"
                        :props="{
                            key: 'journalId',
                            label: 'journalName'
                        }"
                        :titles="['备选期刊', '已选期刊']">
                        <span slot-scope="{ option }">
                          <el-tooltip
                            class="item"
                            effect="dark"
                            :content="option.journalName"
                            placement="top">
                            <span>{{ option.journalName }}</span>
                          </el-tooltip>
                        </span>
                    </el-transfer>
                </el-form-item>
            </el-form>
            <!-- 创建form -->
            <div slot="footer" class="dialog-footer" align="center">
                <el-button @click="closeDialog">取消</el-button>
                <el-button type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
            </div>
        </el-dialog>
    </el-row>
</template>
<script>
    import API_USER from "../../../api/api_user";
    import API_JOURNAL from "../../../api/api_journal";
    import {validaePass1} from "../../../common/validator";
    import {validaeUserName} from "../../../common/validator";

    export default {
        name: "addUserDialog",
        components: {},
        props: {},
        data() {
            return{
                //新增相关数据
                addFormVisible: false, //新增界面是否显示
                addLoading: false, //新增界面加载状态
                addFormRules: {
                    username: [
                        { required: true, message: "请输入用户名", trigger: "blur" },
                        { validator: validaeUserName, trigger: "blur" }
                    ],
                    password: [
                        { required: true, message: "请输入密码", trigger: "blur" },
                        { validator: validaePass1, trigger: "blur" }
                    ],
                    realname: [
                        { required: true, message: "请输入名字", trigger: "blur" }
                    ],
                    roleValue:[
                        { required: true, message: "请选择角色", trigger: "blur" }
                    ],
                    checkdedJournals:[
                        { required: true, message: "请选择管理期刊", trigger: "blur"}
                    ]
                },
                addForm: {
                    username: "",
                    password: "",
                    realname: "",
                    mail:"",
                    phone:"",
                    journalList:[],
                    roleValue: '',
                    checkdedJournals:[],
                },
                roleOptions: [
                    {
                        value: '1',
                        label: '转换管理'
                    }, 
                    {
                        value: '2',
                        label: '上传管理'
                    },
                    {
                        value: '3',
                        label: '审核管理'
                    },
                    {
                        value: '4',
                        label: '数据加工'
                    },
                    {
                        value: '5',
                        label: '自动校对和latex转换'
                    },
                ],
                
            };
        },

        methods:{
            closeDialog() {
                this.addFormVisible = false;
                this.$emit('signStatusVerdict',true);
            },
            openDialog(){
                this.findAllJournal();
                setTimeout(() => {
                    this.addFormVisible = true;
                }, 500);   
            },
            //获取期刊
            findAllJournal(){
                let that = this;
                let params = {};
                API_JOURNAL.getAllJournal(params)
                .then(res=>{
                    if(res && res.journal){
                        that.addForm.journalList = Object.values(res.journal);
                    }
                })
                .catch(e=>{
                    this.$message({
                    showClose:true,
                    type:"error",
                    message:"请求出现异常",
                    duration:2000
                    });
                });
            },
            //获取所有打开审核的期刊
            findAuditJournals(){
                let that = this;
                let params = {};
                API_JOURNAL.getAuditJournals(params)
                .then(res=>{
                    if(res && res.journal){
                    that.addForm.journalList = Object.values(res.journal);
                    console.log(
                        "......findAuditJournals:" + JSON.stringify(that.addForm.journalList)
                        );
                    }
                })
                .catch(e=>{
                    this.$message({
                    showClose:true,
                    type:"error",
                    message:"请求出现异常",
                    duration:2000
                    });
                });
            },
            
            //新增提交
            addSubmit: function() {
                let that = this;
                if (that.formLoading) return;

                that.$refs.addForm.validate(valid => {
                    if (valid) {
                    let params = {
                        username: that.addForm.username,
                        password: that.addForm.password,
                        realname: that.addForm.realname,
                        mail: that.addForm.mail,
                        phone:that.addForm.phone,
                        journalList: that.addForm.checkdedJournals,
                        role:that.addForm.roleValue
                    };

                    console.log(
                        ".........user create by params:" + JSON.stringify(params)
                    );

                    //发送http请求
                    API_USER.addUser(params)
                        .then(res => {
                        if (0 === res.errorCode) {
                            that.$message({
                            type: "success",
                            message: "创建成功!"
                            });

                            that.$refs["addForm"].resetFields(); //清空数据
                            that.addFormVisible = false;
                            that.$emit('signStatusVerdict',true);
                        } else {
                            that.$message({
                            showClose: true,
                            message: res.errorInfo,
                            type: "error"
                            });
                        }
                        })
                        .catch(e => {
                        that.$message({
                            showClose: true,
                            type: "error",
                            message: "请求出现异常",
                            duration: 2000
                        });
                        });
                    } else {
                    that.$message({
                        showClose: true,
                        type: "error",
                        message: "请正确填写信息！",
                        duration: 2000
                    });
                    }
                });
            },

            roleSelectChanged(value){
                //先清空已选择的期刊
                this.addForm.journalList=[];
                if(value === '3'){
                    //如果选择了审核管理，则只显示配置了审核期刊的机构
                    this.findAuditJournals();
                    setTimeout(() => {
                        this.addFormVisible = true;
                    }, 500);  
                }
                else{
                    //其他情况则显示所有机构
                    this.findAllJournal();
                    setTimeout(() => {
                        this.addFormVisible = true;
                    }, 500);  
                }
            }
            
        },
    };
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/views/SysMng/User/AddUser.vue